import { Col, Row } from 'reactstrap';
import {
  CondicaoPagamentoRecursoRow,
  Container,
  Label,
  Typography,
} from './styles';

export default function Observacao({
  observacaoDescricao,
}: {
  observacaoDescricao: string | undefined | null;
}): JSX.Element {
  return (
    <Container hidden={!observacaoDescricao}>
      <Row>
        <Typography variant="h6" className="float-left mb-3">
          <strong>OBSERVAÇÃO:</strong>
        </Typography>
      </Row>

      <Col>
        <Label>{observacaoDescricao}</Label>
      </Col>
      <CondicaoPagamentoRecursoRow />
    </Container>
  );
}
